import React from 'react';
import Pane from '../components/Pane';

const RecipesPage = () => {
  return (
    <div className="page-container">
      <Pane />
    </div>
  );
};

export default RecipesPage;